import { render, staticRenderFns } from "./CustomPConfirmation.vue?vue&type=template&id=549e1632&scoped=true&"
import script from "./CustomPConfirmation.vue?vue&type=script&lang=js&"
export * from "./CustomPConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CustomPConfirmation.vue?vue&type=style&index=0&id=549e1632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e1632",
  null
  
)

export default component.exports